import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import img001 from "../../images/jointSand/blog-joint-sand-001.jpg";
import img002 from "../../images/jointSand/blog-joint-sand-002.jpg";
import img003 from "../../images/jointSand/blog-joint-sand-003.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const JointSandData = {
  title: "How to Secure Joint Sand Between Pavers",
  image: img001,
  destination: "/blog/how-to-secure-joint-sand-between-pavers",
  date: "January 22, 2016",
  categories: ["blog", "paving-stones"],
};

const JointSand = () => {
  const blog = [JointSandData];

  return (
    <>
      <SEO
        title="How to Replace and Secure Joint Sand Between Pavers"
        description="Learn how to replace and secure joint sand between pavers from our experts at Pacific Pavingstone. Have more questions? Contact us today!"
        profileURL={
          "https://www.pacificpavingstone.com/blog/how-to-secure-joint-sand-between-pavers"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/how-to-secure-joint-sand-between-pavers",
          headline: "How to Replace and Secure Joint Sand Between Pavers",
          description:
            "Learn how to replace and secure joint sand between pavers from our experts at Pacific Pavingstone. Have more questions? Contact us today!",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/blog-joint-sand-001.7323b314.jpg",
          },
          datePublished: "2016-01-22",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              Durable and attractive, pavers make a great choice for outdoor
              flooring. Sustaining their beauty requires little work.
              <br />
              <br />
              However, since pavers are exposed to various elements such as rain
              and wind, the joint sand between pavers may get washed out
              overtime. Occasional washing can also cause the joint sand to
              corrode.
              <br />
              <br />
              This compacted sand plays an important role as it locks the pavers
              together. It also keeps weeds at bay by preventing water from
              entering through the cracks.
            </p>
            <h4>Replacing Loss Joint Sand</h4>
            <img src={img002} alt="Feature" />
            <p>
              The joint sand is key to maintaining the strength of the paver
              installation.
              <br />
              <br />
              The sand prevents the pavers from shifting and sliding against
              each other. Hence, dislodged sand will have to be replenished to
              keep the paver system structurally sound.
              <br />
              <br />
              To replace sand that has been washed out, simply pour joint sand
              over the pavers. Next, sweep it into and across the joints using a
              stiff push broom.
              <br />
              <br />
              Keep the depth of the sand at ¼ inch from the surface of the
              paver. Afterwards, you can sweep the excess joint sand between
              pavers and store it again for future use.
              <br />
              <br />
              Note that this is a special type of sand that is available in most
              hardwares. You can also ask your paver installer for
              recommendations where to purchase the joint sand.
            </p>
            <h4>Preventing Joint Sand Between Pavers from Washing Out</h4>
            <img src={img003} alt="Feature" />
            <p>
              You can protect the joint sand from washing out by sealing the
              paver surface. Sealing restores the beauty of your pavers.
              <br />
              <br />
              The paver sealer also serves as glue between the joint sand
              particles hence holding them together, and preventing the sand
              from being washed away when it rains or during pressure washing.
              <br />
              <br />
              The sealer wears off after a few years so make sure to clean the
              pavers and seal the surface again. This will keep the pavers
              looking new, and also boost their resistance against weed and
              moss.
              <br />
              <br />
              Sealing also helps stabilize the joint sand – a simple preventive
              measure you can practice to increase paver longevity.
              <br />
              <br />
              In addition, paver sealer protects pavers from oil, rust, and
              other stains. But always remember that when it comes to removing
              dirt on pavers, the sooner you act, the easier it is.
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(JointSand);
